module.exports = __webpack_public_path__ + "img/Logo.160c2abb.png";